import '../styles/footer.css'
import { Link } from 'react-router-dom'

export default function Footer() {
    const currentYear = new Date().getFullYear();
    
    return(
        <div id="footer">
            <div className="footer-section">
                <Link to="/"><img src="/img/logos/logo-full-white.png" alt="Blue and white CLV logo."></img></Link>
            </div>
            <div id="terms" className="footer-section">
                <Link to="/terms-of-use">Terms of Use &nbsp; </Link> | <Link to="/privacy-policy">&nbsp;  Privacy Policy</Link>
            </div>
            <div id="copyright" className="footer-section">
                <p>Corsianos Lee Vashishth LLP © {currentYear}.<br className="line-break"/> All Rights Reserved.</p>
            </div>

            {/*<div className="footer-section">
                <p>6 Ronrose Dr - Suite 301<br/>
                    Concord, ON<br/>
                    L4K 4R3<br/>
                    Canada</p>
            </div>*/}
            
        </div>
    );
}
